import { fromJS } from "immutable";
import ACTIONS from "../constants";

const initialState = fromJS({
  error: "",
  reshuffleRequests: [],
  reshuffleRequestPagination: {},
  reshuffleRequestLoading: false,
  pageLoading: false,
});

export default function reshuffleRequestReducer(state = initialState, action) {
  switch (action.type) {
    // ── List ──────────────────────────────────────────────────────────────
    case ACTIONS.RESHUFFLE_REQUEST.PENDING:
      return state.set("error", "").set("reshuffleRequestLoading", true);
    case ACTIONS.RESHUFFLE_REQUEST.SUCCESS:
      return state
        .set("reshuffleRequestLoading", false)
        .set("reshuffleRequests", action.data.data)
        .set("reshuffleRequestPagination", action.data.pagination);
    case ACTIONS.RESHUFFLE_REQUEST.ERROR:
      return state.set("reshuffleRequestLoading", false).set("error", action.error);

    // ── Mutations pending ──────────────────────────────────────────────────
    case ACTIONS.CREATE_RESHUFFLE_REQUEST.PENDING:
    case ACTIONS.UPDATE_RESHUFFLE_REQUEST.PENDING:
    case ACTIONS.DELETE_RESHUFFLE_REQUEST.PENDING:
    case ACTIONS.SUBMIT_RESHUFFLE_REQUEST.PENDING:
    case ACTIONS.APPROVE_RESHUFFLE_REQUEST.PENDING:
    case ACTIONS.REJECT_RESHUFFLE_REQUEST.PENDING:
    case ACTIONS.EXECUTE_RESHUFFLE_REQUEST.PENDING:
    case ACTIONS.CANCEL_RESHUFFLE_REQUEST.PENDING:
      return state.set("pageLoading", true).set("error", "");

    // ── Mutations success ──────────────────────────────────────────────────
    case ACTIONS.CREATE_RESHUFFLE_REQUEST.SUCCESS:
    case ACTIONS.UPDATE_RESHUFFLE_REQUEST.SUCCESS:
    case ACTIONS.DELETE_RESHUFFLE_REQUEST.SUCCESS:
    case ACTIONS.SUBMIT_RESHUFFLE_REQUEST.SUCCESS:
    case ACTIONS.APPROVE_RESHUFFLE_REQUEST.SUCCESS:
    case ACTIONS.REJECT_RESHUFFLE_REQUEST.SUCCESS:
    case ACTIONS.EXECUTE_RESHUFFLE_REQUEST.SUCCESS:
    case ACTIONS.CANCEL_RESHUFFLE_REQUEST.SUCCESS:
      return state
        .set("pageLoading", false)
        .set("reshuffleRequests", action.data.data)
        .set("reshuffleRequestPagination", action.data.pagination);

    // ── Mutations error ────────────────────────────────────────────────────
    case ACTIONS.CREATE_RESHUFFLE_REQUEST.ERROR:
    case ACTIONS.UPDATE_RESHUFFLE_REQUEST.ERROR:
    case ACTIONS.DELETE_RESHUFFLE_REQUEST.ERROR:
    case ACTIONS.SUBMIT_RESHUFFLE_REQUEST.ERROR:
    case ACTIONS.APPROVE_RESHUFFLE_REQUEST.ERROR:
    case ACTIONS.REJECT_RESHUFFLE_REQUEST.ERROR:
    case ACTIONS.EXECUTE_RESHUFFLE_REQUEST.ERROR:
    case ACTIONS.CANCEL_RESHUFFLE_REQUEST.ERROR:
      return state.set("pageLoading", false).set("error", action.error);

    default:
      return state;
  }
}
